import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, Subject, BehaviorSubject, Subscription, of } from "rxjs";
import { UntypedFormControl } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { PdfprintService } from "./pdfprint.service";
``;
import { CommerrorService } from "./commerror.service";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  contLogin = false;
  username: string;
  limits;
  public premissions = null;
  totpVerify = false;
  public invasiveExams = false;
  UID;
  linksent;
  base64;
  clinicUsers;
  public loggedIn = false;
  loginError: string;
  getCode = false;
  lastAwl: string;
  lastAwlExam: string;
  lastAwlStartDate: any;
  lastAwlEnDate: any;
  export$ = new Subject<any>();
  exportLoading = false;
  ENVLoaded = new Subject();
  public category = {
    name: "doctor",
    canOpen: {
      form: true,
      exam: true,
    },
    canCreate: {
      form: true,
      exam: true,
    },
    canChange: {
      form: true,
      exam: true,
    },
    canSend: {
      form: true,
      exam: true,
    },
    todayList: true,
  };
  public hastech = false;
  public Recording: string;
  public RemoteRTC = false;
  public hasAWL = false;
  public AWLUnlimited = false;
  public bitRate = 500000;
  public highBit = 3000000;
  public AWLOnlyExams = false;
  public onLogin: Subject<null>;
  public onFailedLogin: Subject<null>;
  public canOpenExams: boolean;
  public fullDelivery: string = "download";
  public printLang: string = null;
  public printStyle: string = null;
  public userType = "doctor";
  public summaryOnlyAnamolies = false;
  archiveServer: string;
  loginname: string;
  public printAllMeas = true;
  public dopplerAutoOk = true;
  public RequireLoginToOpen = false;
  public anatomyAltNames;
  public hasChameleon = true;
  public hasFollicles = true;
  public defaultsButton = false;
  public links = true;
  public Clinic: string;
  public ClinicID: number;
  public localServer = false;
  public letterhead = false;
  location: string;
  public VideoCodec = "video/webm;codecs=vp9";
  public clinicOptions;
  public ishospital: any = false;
  public hasLeumit = false;
  public isCardio = false;
  public isGastro = false;
  public isEyes = true;
  public isSite = false; // sites partnership: current clinic is an acquisition site
  public PRNcheck = true;
  public requireExamLogon = true;
  public AWLExamNames = false;
  public hasEmergencyRoom = false;
  public altArchiveName: string = null;
  public CustomHeader = new UntypedFormControl(false);
  picAlt = "Header Pic";
  headerToShow;
  isImageLoading = false;
  public altSplashPage;
  public isAdmin = false;
  public noneAsMeasDefault = false;
  public LeumitAdmin = false;
  public barcodeScan = false;
  public ExamCodes;
  public hasENV = false;
  public doctor = null;
  public PeerServ: { host: string; port: number; path: string };
  public separatedClinic = false;
  public SeparateZimun = false;
  public officeServer = false;
  public clinicConnectors = [];
  private sessionExpiration = new BehaviorSubject<string>("");
  private sessionExpirationSubscription: Subscription;
  private timeoutId: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private sanitization: DomSanitizer,
    private pdf: PdfprintService,
    private commerrorService: CommerrorService,
  ) {
    this.onLogin = new Subject();
    this.onFailedLogin = new Subject();
    this.http.get("/api/getenv").subscribe(
      (data) => {
        let p = {};
        p["env"] = data;
        this.setEnv(p);
      },
      (error) => {
        console.log(error);
      },
    );
  }

  login(
    user: string,
    pw: string,
    navigate = true,
    exam = false,
    isexport = false,
  ) {
    if (!exam) {
      if (this.ishospital) {
        this.localServer = false;
        let req = this.http.post("/api/login", {
          user: user,
          pw: pw,
          inside: exam,
        });
        if (isexport) this.followLogin(req, navigate, user, true);
        else this.followLogin(req, navigate, user);
      } else {
        this.http.get("http://localhost:8088/alive").subscribe(
          (data) => {
            if (data["status"] == "alive") this.localServer = true;
            this.http.get("http://localhost:8088/whereami").subscribe(
              (data) => {
                if (data["office_server"]) {
                  this.officeServer = true;
                  this.ldapLogin(user, pw, data, navigate);
                  return;
                }
                if (data["location"]) {
                  let req = this.http.post("/api/login", {
                    user: user,
                    pw: pw,
                    inside: exam,
                    location: data["location"],
                  });
                  this.followLogin(req, navigate, user);
                }
              },
              (error) => {
                let req = this.http.post("/api/login", {
                  user: user,
                  pw: pw,
                  inside: exam,
                });
                this.followLogin(req, navigate, user);
                console.log(error);
              },
            );
          },
          (error) => {
            this.localServer = false;
            let req = this.http.post("/api/login", {
              user: user,
              pw: pw,
              inside: exam,
            });
            this.followLogin(req, navigate, user);
          },
        );
      }
    }
  }

  followLogin(req, navigate = true, user = null, isexport = false, silent = false) {
    this.clinicOptions = null;
    req.subscribe(
      (data) => {
        // Loginbox re-auth: clinic already selected — validate only, preserve all state.
        // `silent` (reading-hub clinic switch) bypasses this so the session is re-scoped.
        if (!navigate && !silent && this.ClinicID && data?.["status"] === "ok" && !data?.["code"]) {
          this.loginError = null;
          this.contLogin = false;
          this.onLogin.next(null);
          return;
        }
        if (
          data.hasOwnProperty("status") &&
          data["status"] == "ok" &&
          !data.hasOwnProperty("code")
        ) {
          if (isexport) {
            this.export$.next(this.exportData());
            return;
          }
          this.Clinic = null;
          if (data["Clinic"]) {
            this.Clinic = data["Clinic"];
            //try local server
          }
          this.loginError = null;
          this.loginname = user;
          this.UID = data["uid"];
          this.username = data["uname"];
          this.LeumitAdmin = data["HMO"];
          this.totpVerify = data["TOTPSet"];
          this.separatedClinic = false;
          if (data["hasSeparation"]) this.separatedClinic = true;
          if (data["SeparateZimun"]) this.SeparateZimun = true;
          else this.SeparateZimun = false;
          if (data["membership"]) {
            switch (data["membership"]) {
              case "forms":
                this.category = {
                  name: data["category"],
                  canOpen: {
                    form: true,
                    exam: false,
                  },
                  canCreate: {
                    form: true,
                    exam: false,
                  },
                  canChange: {
                    form: true,
                    exam: false,
                  },
                  canSend: {
                    form: true,
                    exam: false,
                  },
                  todayList: true,
                };
                break;
              case "tech":
                this.category = {
                  name: data["category"],
                  canOpen: {
                    form: true,
                    exam: true,
                  },
                  canCreate: {
                    form: true,
                    exam: true,
                  },
                  canChange: {
                    form: true,
                    exam: true,
                  },
                  canSend: {
                    form: true,
                    exam: true,
                  },
                  todayList: true,
                };
                break;
              case "secretary":
                this.category = {
                  name: data["category"],
                  canOpen: {
                    form: false,
                    exam: false,
                  },
                  canCreate: {
                    form: false,
                    exam: false,
                  },
                  canChange: {
                    form: false,
                    exam: false,
                  },
                  canSend: {
                    form: false,
                    exam: true,
                  },
                  todayList: true,
                };
                break;
              case "nurse":
                this.category = {
                  name: data["category"],
                  canOpen: {
                    form: true,
                    exam: true,
                  },
                  canCreate: {
                    form: true,
                    exam: false,
                  },
                  canChange: {
                    form: true,
                    exam: false,
                  },
                  canSend: {
                    form: true,
                    exam: true,
                  },
                  todayList: true,
                };
                break;
              case "doctor":
                this.category = {
                  name: data["category"],
                  canOpen: {
                    form: true,
                    exam: true,
                  },
                  canCreate: {
                    form: true,
                    exam: true,
                  },
                  canChange: {
                    form: true,
                    exam: true,
                  },
                  canSend: {
                    form: true,
                    exam: true,
                  },
                  todayList: true,
                };
                break;
              default:
                this.category = {
                  name: data["category"],
                  canOpen: {
                    form: true,
                    exam: true,
                  },
                  canCreate: {
                    form: true,
                    exam: true,
                  },
                  canChange: {
                    form: true,
                    exam: true,
                  },
                  canSend: {
                    form: true,
                    exam: true,
                  },
                  todayList: true,
                };
                break;
            }
          }
          this.getLimits();
          if (data["membership"]) this.userType = data["membership"];
          if (data["locations"]) {
            let locationsString = data["locations"];

            // Check if the string starts with a comma and remove it
            if (locationsString.startsWith(",")) {
              locationsString = locationsString.slice(1);
            }

            // Split the string into an array using commas
            this.clinicConnectors = locationsString.split(",");

            // Now, this.clinicConnectors is an array containing the values
          } else {
            //no login
            if (data["env"]["requiregroup"]) {
              this.loginError = "User is not authorized to use this system";
              return;
            }
            this.userType = "doctor"; //otherwise assume doctor
          }
          // this.isAdmin = data['isAdmin'];
          this.isAdmin = data["isAdmin"];
          this.clinicUsers = data["users"];
          if (this.userType == "doctor" && this.separatedClinic)
            this.doctor = this.UID;
          this.canOpenExams = data["openExams"];
          if (data["clinics"]) {
            this.clinicOptions = data["clinics"];
          } else {
            this.onLogin.next(undefined);
            if (navigate) this.router.navigate(["/patsearch"]);
          }
        }
        if (data.hasOwnProperty("letterhead"))
          this.letterhead = data["letterhead"];
        else this.letterhead = false;
        this.requireExamLogon = data["requireExamLogon"];
        this.isSite = !!data["isSite"];
        this.setEnv(data);
        if (data["GID"]) {
          this.ClinicID = data["GID"];

          this.http
            .get(`/api/login/getTOS/${this.loginname}`)
            .subscribe((data) => {
              this.premissions = data[0];
            });
        }
        if (data.hasOwnProperty("code")) {
          this.getCode = true;
        }
        if (data.hasOwnProperty("error")) {
          this.loginError = data["error"];
        }
        this.contLogin = false;
      },
      (error) => {
        this.loginError = error.error.error;
      },
    );
    return req;
  }

  setEnv(data) {
    this.ishospital = data["env"]["ishospital"];
    if (data["env"]) {
      if (data["env"]["recording"]) {
        this.Recording = data["env"]["recording"];
        if (data["env"]["webrtc"] == "remote") {
          this.RemoteRTC = true;
          this.PeerServ = data["env"]["peerServer"];
        }
      }
      if (this.ishospital) {
        this.premissions = data["env"]["premissions"];
        this.invasiveExams = this.premissions.ObstetricInvasive;
      }
      if (data["env"]["hasTech"]) this.hastech = data["env"]["hasTech"];
      if (data["env"]["bitRate"]) this.bitRate = data["env"]["bitRate"];
      if (data["env"]["highBitrate"]) this.highBit = data["env"]["highBitrate"];
      if (data["env"]["AWL"]) this.hasAWL = true;
      if (data["env"].hasOwnProperty("AWLOnlyExamOpening"))
        this.AWLOnlyExams = data["env"]["AWLOnlyExamOpening"];
      if (data["env"]["printLang"]) {
        this.printLang = data["env"]["printLang"];
        this.pdf.Lang = data["env"]["printLang"];
      }
      if (data["env"]["printStyle"])
        this.printStyle = data["env"]["printStyle"];
      if (this.ishospital) this.RequireLoginToOpen = true;
      else {
        if (data["env"]["RequireLoginToOpen"])
          this.RequireLoginToOpen = data["env"]["RequireLoginToOpen"];
      }
      if (data["env"]["FullDelivery"])
        this.fullDelivery = data["env"]["FullDelivery"];
      if (data["env"]["AWLUnlimitedExams"])
        this.AWLUnlimited = data["env"]["AWLUnlimitedExams"];
      if (data["env"].hasOwnProperty("dopplerAutoOK"))
        this.dopplerAutoOk = data["env"]["dopplerAutoOK"];
      if (data["env"].hasOwnProperty("hasChameleon"))
        this.hasChameleon = data["env"]["hasChameleon"];
      if (data["env"].hasOwnProperty("hasFollicles"))
        this.hasFollicles = data["env"]["hasFollicles"];
      if (data["env"]["videoCodec"])
        this.VideoCodec = data["env"]["videoCodec"];
      if (data["env"]["archiveserv"])
        this.archiveServer = data["env"]["archiveserv"];
      if (data["env"]["anomaliesInSummary"])
        this.summaryOnlyAnamolies = data["env"]["anomaliesInSummary"];
      if (data["env"]["altNames"])
        this.anatomyAltNames = data["env"]["altNames"];
      if (data["env"]["defaultsButton"])
        this.defaultsButton = data["env"]["defaultsButton"];
      if (data["env"].hasOwnProperty("smslink"))
        this.links = data["env"]["smslink"];
      if (data["env"].hasOwnProperty("noprncheck"))
        this.PRNcheck = !data["env"].noprncheck;
      if (data["env"]["altSplash"])
        this.altSplashPage = data["env"]["altSplash"];
      if (data["env"]["hasEmergencyRoom"]) this.hasEmergencyRoom = true;
      if (data["env"]["awlExamNames"])
        this.AWLExamNames = data["env"]["awlExamNames"];
      if (data["env"]["altArchiveName"])
        this.altArchiveName = data["env"]["altArchiveName"];
      if (data["env"].hasOwnProperty("measDefaultNone"))
        this.noneAsMeasDefault = data["env"]["measDefaultNone"];
      if (data["env"]["barcodeScan"])
        this.barcodeScan = data["env"]["barcodeScan"];
      if (data["env"]["examCodes"]) this.ExamCodes = data["env"]["examCodes"];
    }
    if (data["Language"]) {
      this.printLang = data["Language"];
      this.pdf.Lang = data["Language"];
    }
    if (data.hasOwnProperty("hasLeumit")) {
      this.hasLeumit = data.hasLeumit;
    }

    this.isCardio = true;
    this.isEyes = true;

    // if(data['isCardio'])
    // else
    //   this.isCardio = false;

    if (this.userType) {
      switch (this.userType) {
        case "doctor":
          this.lastAwl = "Completed";
          break;
        case "tech":
          this.lastAwl = "Received";
          break;
        case "secretary":
          this.lastAwl = "Waiting";
          break;
      }
    }
    this.ENVLoaded.next(undefined);
    this.hasENV = true;
  }

  sendCode(code: string) {
    let req = this.http.get("api/logincode", { params: { code: code } });
    req.subscribe(
      (data) => {
        if (data.hasOwnProperty("status") && data["status"] == "ok") {
          this.loginError = null;
          this.username = data["uname"];
          this.getCode = false;
          this.router.navigate(["/patsearch"]);
        }
        if (data.hasOwnProperty("error")) {
          this.loginError = data["error"];
        }
      },
      (error) => {
        this.loginError = error.error.error;
      },
    );
  }

  public getUserName() {
    return this.username;
  }

  loginAsCurrentUser() {
    if (this.username && !this.requireExamLogon) this.onLogin.next(undefined);
  }

  ldapLogin(user: string, pw: string, serv, navigate = false) {
    this.http
      .post("http://localhost:8088/login", { login: user, pw: pw })
      .subscribe(
        (data) => {
          if (data.hasOwnProperty("error")) {
            this.loginError = data["error"];
          } else {
            if (serv["location"]) data["location"] = serv["location"];
            this.followLogin(
              this.http.post("/remote/login", data),
              navigate,
              user,
            );
          }
        },
        (err) => {
          console.log(err);
          this.loginError = err.error.error;
        },
      );
  }

  public getArchiveServer(): string {
    return this.archiveServer;
  }

  public async Logout() {
    (await this.clearCookies()).subscribe((data) => {
      this.clinicOptions = null;
      this.router.navigate([""]);
      this.export$.next(false);
      this.totpVerify = false;
    });
  }

  async clearCookies() {
    return this.http.get("/api/login/clearCookies");
  }

  public canStartExam(hasawl: boolean): boolean {
    return (
      this.canOpenExams &&
      (this.ishospital || this.localServer) &&
      (this.userType == "doctor" || this.userType == "tech") &&
      (!this.AWLOnlyExams || (this.AWLOnlyExams && hasawl))
    );
  }

  public loginMissing() {
    if (!this.username) this.router.navigate(["/"]);
  }

  public showAWL(): boolean {
    return (
      this.hasAWL &&
      (!this.ishospital ||
        this.userType == "doctor" ||
        this.userType == "tech" ||
        this.userType == "secretary")
    );
  }

  setClinic(id: number) {
    const req = this.http.get("/api/setclinic/" + this.clinicOptions[id].GID);
    this.followLogin(req, true, this.loginname);
  }

  // Reading hub: switch the whole session to another site clinic without
  // navigating, so an exam there can be opened in the current view. Resolves
  // once the login-shaped setclinic response has been applied.
  silentSetClinic(gid: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.get("/api/setclinic/" + gid).subscribe({
        next: (data: any) => {
          if (data?.status === "ok") {
            this.followLogin(of(data), false, this.loginname, false, true);
            setTimeout(resolve, 0);
          } else {
            reject(data);
          }
        },
        error: (err) => reject(err),
      });
    });
  }

  getUserType() {
    return this.userType;
  }

  saveHeader(formData) {
    this.http
      .post(
        `/api/NewExams/setHeader/${this.CustomHeader.value ? "y" : "n"}`,
        formData,
      )
      .subscribe((data) => {
        console.log(data);
      });
  }

  getHeader() {
    this.http.get("/api/NewExams/getHeader").subscribe((data) => {
      if (data["CustomLogo"]) {
        this.CustomHeader.patchValue(data["CustomLogo"]);
      }
      if (
        (data["PrintHeader"] || data["PrintHeaderCustom"]) &&
        !this.ishospital &&
        !this.isCardio
      )
        this.getImageFromService();
    });
  }
  chaneHeader() {
    this.http
      .post("/api/NewExams/chageHeaderSetting", {
        CustomLogo: this.CustomHeader.value,
      })
      .subscribe();
  }

  getImage(): Observable<Blob> {
    if (this.ishospital) {
      if (this.CustomHeader.value) {
        this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`;
      } else {
        this.headerToShow = `../../assets/images/clinic.jpg`;
      }
    } else {
      if (this.CustomHeader.value) {
        return this.http.get(`/api/NewExams/getImage/y`, {
          responseType: "blob",
        });
      } else {
        return this.http.get(`/api/NewExams/getImage/n`, {
          responseType: "blob",
        });
      }
    }
  }
  createImageFromBlob(image: Blob) {
    // this.headerToShow = this.sanitization.bypassSecurityTrustUrl(URL.createObjectURL(image))
    let reader = new FileReader();
    reader.addEventListener(
      "load",
      () => {
        this.base64 = reader.result;
        // this.headerToShow = reader.result;
        this.headerToShow = this.sanitization.bypassSecurityTrustUrl(
          this.base64,
        );
      },
      false,
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }
  getImageFromService() {
    this.isImageLoading = true;
    if (this.ishospital) {
      if (this.CustomHeader.value) {
        this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`;
      } else {
        this.headerToShow = `../../assets/images/clinic.jpg`;
      }
    }
  }

  exportData() {
    this.exportLoading = true;
    return this.http.get("/api/stats/exportdata");
  }

  getTOTP(uname, pw) {
    return this.http.post("/api/login/getTOTPSet", { uname: uname, pw: pw });
  }

  getDocByUID(uid: number) {
    for (let usr of this.clinicUsers) {
      if (usr.UID == uid) return usr.Name;
    }
    return "";
  }

  getLimits() {
    this.http.get("/api/limits").subscribe((data) => {
      this.limits = data;
    });
  }

  countLinks() {
    this.http.get("/api/NewExams/countLinks").subscribe((data: any) => {
      this.linksent = data;
    });
  }
}
